export type LeadIntakeFieldType =
  | 'text'
  | 'email'
  | 'phone'
  | 'textarea'
  | 'select'
  | 'checkbox'
  | 'hidden';

export type CaptchaProvider = 'recaptcha_v3' | 'hcaptcha';

export const LEAD_INTAKE_FIELD_TYPES: LeadIntakeFieldType[] = [
  'text',
  'email',
  'phone',
  'textarea',
  'select',
  'checkbox',
  'hidden',
];

export const LEAD_INTAKE_FIELD_TYPE_LABEL: Record<LeadIntakeFieldType, string> = {
  text: 'Testo',
  email: 'Email',
  phone: 'Telefono',
  textarea: 'Area testo',
  select: 'Lista a tendina',
  checkbox: 'Checkbox',
  hidden: 'Nascosto',
};

export const CAPTCHA_PROVIDER_LABEL: Record<CaptchaProvider, string> = {
  recaptcha_v3: 'Google reCAPTCHA v3',
  hcaptcha: 'hCaptcha',
};

export interface IntakeFieldDef {
  name: string;
  label: string;
  type: LeadIntakeFieldType;
  required: boolean;
  options?: string[];
  placeholder?: string | null;
}

export interface LeadIntakeFormBase {
  slug: string;
  titolo: string;
  descrizione?: string | null;
  fields: IntakeFieldDef[];
  allowed_origins: string[];
  rate_limit_per_hour: number;
  captcha_provider?: CaptchaProvider | null;
  captcha_secret?: string | null;
  redirect_url?: string | null;
  is_active: boolean;
  assigned_agente_id?: string | null;
}

export type LeadIntakeFormCreate = LeadIntakeFormBase;
export type LeadIntakeFormUpdate = Partial<LeadIntakeFormBase>;

export interface LeadIntakeFormResponse {
  id: string;
  tenant_id: string;
  slug: string;
  titolo: string;
  descrizione?: string | null;
  fields: IntakeFieldDef[];
  allowed_origins: string[];
  rate_limit_per_hour: number;
  captcha_provider?: CaptchaProvider | null;
  has_captcha_secret: boolean;
  redirect_url?: string | null;
  is_active: boolean;
  assigned_agente_id?: string | null;

  created_at: string;
  updated_at?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
  is_deleted: boolean;
}

export interface LeadIntakeFormBriefWithStats {
  id: string;
  slug: string;
  titolo: string;
  is_active: boolean;
  rate_limit_per_hour: number;
  captcha_provider?: CaptchaProvider | null;
  submissions_30d: number;
  created_at: string;
}

export interface LeadIntakeFormListResponse {
  success: boolean;
  data: LeadIntakeFormBriefWithStats[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export interface LeadIntakeFormStats {
  submissions_total: number;
  submissions_30d: number;
  submissions_by_day_30d: Record<string, number>;
}

export interface RotateSlugResponse {
  id: string;
  slug: string;
  old_slug: string;
}
